import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserDeletionFailedAction = {
	type: 'USER_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserDeletionFailedAction => ({
	type: 'USER_DELETION_FAILED',
	payload,
});
